import React from 'react';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';
import Slider from '../components/Slider';

import DivImage from '../assets/images/icon3.png';
import GridImage1 from '../assets/images/icon5.jpeg';
import GridImage2 from '../assets/images/icon4.png';
import GridImage3 from '../assets/images/icon1.png';
import GridImage4 from '../assets/images/icon2.png';

const Homepage = () => {
  return (
    <div className="relative">
      {/* Slider */}
      <Slider />

      {/* Bizi Tanıyın Bölümü */}
      <div className="py-16 px-4">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-[#2E3192] mb-8">
            Bizi Tanıyın
          </h2>
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-8">
          20 yıllık Endüstriyel Ürün Tamiri ve Otomasyon tecrübemizi, siz değerli müşterilerimizle paylaşmak için buradayız. Ürünlerinizi uzmanlığımızla yeniden hayata döndürmeyi ve iş süreçlerinize katkı sağlamayı hedefliyoruz.
          </p>
          <Link 
            to="/about-us"
            className="inline-flex items-center bg-[#2E3192] hover:bg-[#CCDC59] text-white hover:text-[#2E3192] px-6 py-2 rounded-lg font-semibold text-lg transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            <Icon icon="mdi:arrow-right" className="w-4 h-4 mr-2" />
            Devamı için tıklayınız
          </Link>
        </div>
      </div>

      {/* Hizmetler Grid Bölümü */}
      <div className=" py-8 px-4">
        <div className="bg-gray-50 max-w-[1440px] mx-auto">
          <div className="grid md:grid-cols-3 items-center gap-8 lg:px-8 px-2 bg-transparent shadow-md rounded-lg p-4">
            {/* Servo Sürücü */}
            <div className="text-center">
              <h3 className="text-lg font-bold text-[#2E3192] mb-4 leading-tight">
                Servo Sürücüleriniz Emin Ellerde!
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Servo sürücülerdeki elektronik kart arızaları, uzman teknik ekibimiz tarafından hızlı ve güvenilir şekilde onarılmaktadır. 
                Tüm bakım ve onarım işlemleri titizlikle gerçekleştirilir; böylece cihazlarınız daha uzun ömürlü ve verimli çalışır.
                Farklı marka ve modellerdeki servo sürücüler için profesyonel destek sunuyor, sistemlerinizin kesintisiz çalışmasını sağlıyoruz.
              </p>
              <div className="flex justify-center pt-2">
                    <Link 
                      to="/repair-maintenance"
                      className="inline-flex items-center text-[#2E3192] hover:text-[#CCDC59] font-semibold text-sm transition-all duration-300"
                    >
                      Devamını Gör
                      <Icon icon="mdi:arrow-right" className="w-4 h-4 ml-1" />
                    </Link>
              </div>
            </div>

            {/* Fotoğraf Bölümü */}
            <div className="flex items-center justify-center">
              <img src={DivImage} alt="DivImage" className="max-w-full h-auto rounded-lg" />
            </div>

            {/* HMI/Endüstriyel PC */}
            <div className="text-center">
              <h3 className="text-lg font-bold text-[#2E3192] mb-4 leading-tight">
                HMI / Endüstriyel PC Kart Tamiri Hizmeti
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Endüstriyel dokunmatik paneller (HMI) ve endüstriyel PC’lerde meydana gelen elektronik kart arızaları, ekran görüntü problemleri ve dokunmatik algılama sorunları uzman ekibimiz tarafından hızlı ve güvenli bir şekilde onarılır.
              </p>
              <div className="flex justify-center pt-2">
                    <Link 
                      to="/repair-maintenance"
                      className="inline-flex items-center text-[#2E3192] hover:text-[#CCDC59] font-semibold text-sm transition-all duration-300"
                    >
                      Devamını Gör
                      <Icon icon="mdi:arrow-right" className="w-4 h-4 ml-1" />
                    </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Detaylı Hizmetler Bölümü */}
      <div className=" py-8 px-4">
        <div className="max-w-[1440px] mx-auto">
          <div className="grid md:grid-cols-2 gap-16">
            {/* Servo Motor Hizmeti */}
            <div className="bg-gray-50 rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 h-[420px] lg:p-10 p-2">
              <div className="flex flex-col md:flex-row h-full items-center">
                {/* Görsel - Desktop'ta sağda, mobilde solda */}
                <div className="w-full md:w-1/2 lg:h-64 h-32 flex items-center justify-center order-1 md:order-2 pt-8 md:pt-0">
                  <div className="text-center text-white">
                    <img src={GridImage1} alt="GridImage1" className="mx-auto w-[190px] h-[190px] object-contain lg:pb-0 pb-8" />
                  </div>
                </div>
                {/* İçerik - Desktop'ta solda, mobilde sağda */}
                <div className="w-full md:w-1/2 p-8 order-2 md:order-1 flex flex-col justify-center text-center md:text-left">
                  <h3 className="text-lg font-bold text-[#2E3192] mb-4 leading-tight">
                    Servo Motor <br/> Bakım Onarım <br/> Test Hizmetleri
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-4">
                    Servo motorların mekanik onarımı ve enkoder değişimleri yapılır, feedback ekipmanları adapte edilerek sürücü ile test edilir ve çalışır duruma getirilir. Hybrid Motor enkoder değişimleri yapılır ve programlanıp tak çalıştır hale getirilir.
                  </p>
                  <Link 
                    to="/repair-maintenance"
                    className="inline-flex items-center text-[#2E3192] hover:text-[#CCDC59] font-semibold text-sm transition-all duration-300"
                  >
                    Devamını Gör
                    <Icon icon="mdi:arrow-right" className="w-4 h-4 ml-1" />
                  </Link>
                </div>
              </div>
            </div>

            {/* Uzak Bağlantı Hizmeti */}
            <div className="bg-gray-50 rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 h-[420px] lg:p-10 p-2">
              <div className="flex flex-col md:flex-row h-full items-center">
                {/* Görsel - Desktop'ta solda, mobilde solda */}
                <div className="w-full md:w-1/2 lg:h-64 h-32 flex items-center justify-center order-1 pt-8 md:pt-0">
                  <div className="text-center text-white">
                    <img src={GridImage2} alt="GridImage2" className="mx-auto w-[270px] h-[270px] object-contain lg:pb-0 pb-8" />
                  </div>
                </div>
                {/* İçerik - Desktop'ta sağda, mobilde sağda */}
                <div className="w-full md:w-1/2 p-8 order-2 flex flex-col justify-center text-center md:text-right">
                  <h3 className="text-lg font-bold text-[#2E3192] mb-4 leading-tight">
                    Uzak Bağlantı Veya Yerinde <br/> Teknik Servis Hizmeti
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-4">
                    Uzmanlık alanımızdaki ürünlere uzaktan bağlantı veya yerinde servis hizmeti ile analiz ve çözümleme yapılarak sistemleriniz çalışır duruma getirilir.
                  </p>
                  <div className="flex justify-center md:justify-end">
                    <Link 
                      to="/technical-service"
                      className="inline-flex items-center text-[#2E3192] hover:text-[#CCDC59] font-semibold text-sm transition-all duration-300"
                    >
                      Devamını Gör
                      <Icon icon="mdi:arrow-right" className="w-4 h-4 ml-1" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Ürün Satışı */}
            <div className="bg-gray-50 rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 h-[420px] lg:p-10 p-2">
              <div className="flex flex-col md:flex-row h-full items-center">
                {/* Görsel - Desktop'ta sağda, mobilde solda */}
                <div className="w-full md:w-1/2 lg:h-64 h-32 flex items-center justify-center order-1 md:order-2 pt-8 md:pt-0">
                  <div className="text-center text-white">
                    <img src={GridImage3} alt="GridImage3" className="mx-auto w-[270px] h-[270px] object-contain lg:pb-0 pb-8" />
                  </div>
                </div>
                {/* İçerik - Desktop'ta solda, mobilde sağda */}
                <div className="w-full md:w-1/2 p-8 order-2 md:order-1 flex flex-col justify-center text-center md:text-left">
                  <h3 className="text-lg font-bold text-[#2E3192] mb-4 leading-tight">
                    Ürün Satışı
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-4">
                    Servo Sürücü Motor HMI Enkoder Hybrid Güç Enkoder kabloları tedariği satışı ve teknik desteği konusunda hizmet vermekteyiz.
                  </p>
                  <Link 
                    to="/new-product-sales"
                    className="inline-flex items-center text-[#2E3192] hover:text-[#CCDC59] font-semibold text-sm transition-all duration-300"
                  >
                    Devamını Gör
                    <Icon icon="mdi:arrow-right" className="w-4 h-4 ml-1" />
                  </Link>
                </div>
              </div>
            </div>

            {/* Revizyon Hizmeti */}
            <div className="bg-gray-50 rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 h-[420px] lg:p-10 p-2">
              <div className="flex flex-col md:flex-row h-full items-center">
                {/* Görsel - Desktop'ta solda, mobilde solda */}
                <div className="w-full md:w-1/2 lg:h-64 h-32 flex items-center justify-center order-1 pt-8 md:pt-0">
                  <div className="text-center">
                    <img src={GridImage4} alt="GridImage4" className="mx-auto w-[270px] h-[270px] object-contain" />
                  </div>
                </div>
                {/* İçerik - Desktop'ta sağda, mobilde sağda */}
                <div className="w-full md:w-1/2 p-8 order-2 flex flex-col justify-center text-center md:text-right">
                  <h3 className="text-lg font-bold text-[#2E3192] mb-4 leading-tight">
                    Revizyon Ve Devreye Alma Hizmetleri
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-4">
                    Makine otomasyon revizyonu, ürün seri revizyonu, programsal revizyon ve parametrik destek vermekteyiz.
                  </p>
                  <div className="flex justify-center md:justify-end">
                    <Link 
                      to="/technical-service"
                      className="inline-flex items-center text-[#2E3192] hover:text-[#CCDC59] font-semibold text-sm transition-all duration-300"
                    >
                      Devamını Gör
                      <Icon icon="mdi:arrow-right" className="w-4 h-4 ml-1" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* WhatsApp Sabit İkonu */}
      <a 
        href="https://wa.me/905413967820" 
        target="_blank" 
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 group"
      >
        <div className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 animate-pulse">
          <svg 
            className="w-8 h-8" 
            fill="currentColor" 
            viewBox="0 0 24 24"
          >
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
          </svg>
        </div>
        
        {/* Hover Tooltip */}
        <div className="absolute bottom-full right-0 mb-2 hidden group-hover:block">
          <div className="bg-gray-800 text-white text-sm rounded-lg px-3 py-2 whitespace-nowrap">
            WhatsApp ile iletişime geç
            <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"></div>
          </div>
        </div>
      </a>
    </div>
  );
};

export default Homepage;
